import { createFileRoute } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { ClusterDomainEnum } from "schema"
import { z } from "zod"

const ClustersSearchSchema = z.object({
  companyId: z.string().optional(),
  domain: z.enum(ClusterDomainEnum).optional(),
  goalId: z.string().optional(),
  campaignId: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  key: z.string().optional(),
  query: z.string().optional(),
})

export const Route = createFileRoute("/_base/_auth/backoffice/clusters")({
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("backoffice.clusters.title"),
    })
  },
  validateSearch: (search: Partial<z.infer<typeof ClustersSearchSchema>>) => {
    return ClustersSearchSchema.parse(search)
  },
})
